import Skeleton from "@/components/Skeleton";

/**
 * In-page placeholder for `Courses`, shown while its client-side fetch runs.
 *
 * Mirrors the redesigned section exactly - white background, left-aligned
 * heading with its accent rule, optional pill filter chips, and a 12-column
 * grid of rounded cards with a 16:9 image, category label, title and footer
 * row - so the grid does not resize or reflow once the data lands.
 */
export default function CoursesGridSkeleton({
  cards = 6,
  showCategoryFilter = false,
}: {
  cards?: number;
  showCategoryFilter?: boolean;
}) {
  return (
    <section className="bg-white">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-14 lg:py-20">
        {/* Heading + accent rule, left aligned */}
        <div className="mb-10 flex flex-col items-start">
          <Skeleton className="h-9 w-64" />
          <Skeleton className="mt-3 h-1 w-16" shape="pill" />
        </div>

        {showCategoryFilter ? (
          <div className="mb-8 flex flex-wrap gap-2.5">
            {Array.from({ length: 5 }).map((_, i) => (
              <Skeleton key={i} shape="pill" className="h-10 w-28" />
            ))}
          </div>
        ) : null}

        <div className="grid grid-cols-12 gap-6">
          {Array.from({ length: cards }).map((_, i) => (
            <div key={i} className="col-span-12 md:col-span-6 lg:col-span-4">
              <div className="overflow-hidden rounded-2xl border border-slate-200/80 bg-white">
                <Skeleton className=" w-full rounded-none" />
                <div className="space-y-3 p-5">
                  <Skeleton className="h-3 w-20" />
                  <Skeleton className="h-5 w-4/5" />
                  <div className="flex items-center justify-between border-t border-slate-100 pt-4">
                    <Skeleton className="h-4 w-24" />
                    <Skeleton shape="circle" className="h-9 w-9" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
